// extracted by mini-css-extract-plugin
export var iconContainer = "_f2-0";
export var metricCardsContainer = "_f2-1";